module.exports = __webpack_public_path__ + "img/mob2.b3dec75d.png";